export default __webpack_public_path__ + "static/media/TwitterW.c0bb4605.svg";